import { TraderType } from '@Shared/types/TraderType';
import { TraderAdapter } from '@Shared/adapters/Trader.adapter';
import axios from 'axios';
import EnvConfig from '@Config/env.config';

const ROOT_URL = EnvConfig.API_URL;

export async function getTraders(): Promise<{data: TraderType[]}> {
  axios.defaults.headers.get['Access-Control-Allow-Origin'] = '*';
  const response = await axios.get(`${ROOT_URL}/traders`);
  return TraderAdapter.adapt(response.data);
}

// export async function getBanks(): Promise<BankType> {
//   const response = await axios.get(`${ROOT_URL}/banks`);
//   return BankAdapter.adapt(response.data);
// }
